import React, { useEffect, useState } from "react";
import { Box, Typography, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { BiBarChartSquare } from "react-icons/bi";
import MyWorkLineOld from "./MyWorkLineOld";
import { useParams } from "react-router-dom";
import { useGetMyWorkCountQuery, useLazyGetMyWorkListQuery } from "store/slices/apis/myWorkSlice";
import { ReactComponent as ContainerIcon } from "assets/PwC_Funct_Icons_Container_Outline_Black_RGB.svg"
import { ReactComponent as ChevronDownIcon } from "assets/PwC_Funct_Icons_ChevronDown_Outline_Black_RGB.svg"


const myWorkTypes = [
    { key: "document", label: "Engineering Document", path: "document-detail" },
    { key: "issue", label: "Key Issue", path: "issue-detail" },
    { key: "risk", label: "Risk", path: "risk-detail" },
    { key: "clearance", label: "Key Clearance", path: "key-clearance-detail" },
    { key: "safety", label: "Safety", path: "safety-detail" },
    { key: "ncr", label: "Quality", path: "quality-detail" },
    { key: "change", label: "Change Order", path: "key-change-tracker-detail" },
    { key: "claim", label: "Claim", path: "key-claims-detail" },
    { key: "milestone", label: "Milestone", path: "key-milestone-detail" },
    { key: "p&m", label: "P&M", path: "pm-detail" },
    { key: "pmdpr", label: "PM-DPR", path: "pmdpr-detail" },
    { key: "quantitydpr", label: "Schedule DPR", path: "scheduledpr-detail" },
]

const MyWorkKPI = () => {
    const [expanded, setExpanded] = useState('');
    const { projectId } = useParams();
    const myWorkCountRes = useGetMyWorkCountQuery({ projectId });
    const [expandedData, setExpandedData] = useState([]);

    const [myWorkListFun, myWorkListRes] = useLazyGetMyWorkListQuery();

    const handleChange = (panel) => async (event, isExpanded) => {
        if (isExpanded) {
            await myWorkListFun({ projectId, type: panel })
        }
        setExpanded(isExpanded ? panel : false);
    };

    useEffect(() => {

        if (myWorkListRes?.isSuccess) {
            if (myWorkListRes?.data?.status == 'Success') {
                setExpandedData(myWorkListRes?.data?.data)
            }
        }
    }, [myWorkListRes?.isSuccess, expanded])

    return (
        // <Box sx={{ padding: "10px 25px 40px 25px", background: "#fff", borderRadius: "5px", marginTop: "15px" }}>
        <>
            {myWorkTypes?.filter((val) =>
                myWorkCountRes?.data?.data?.find(
                    (item) => item.type.toLowerCase() === val?.key?.toLowerCase()
                )?.count > 0
            )?.map((val, index) => {
                return (
                    <Accordion
                        key={index}
                        onChange={handleChange(val?.key)}
                        expanded={expanded === val?.key}
                    >
                        <AccordionSummary
                            // expandIcon={<ExpandMore />}
                            expandIcon={<ChevronDownIcon style={{ width: '20px', height: "20px", }} />}
                            aria-controls={`${val?.key}${index + 1}-content`}
                            id={`${val?.key}${index + 1}-header`}
                        >
                            <Typography
                                component="span"
                                sx={{
                                    fontWeight: 500,
                                    lineHeight: "24px",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                    fontSize: { xs: '12px', sm: '16px' }
                                }}
                            >
                                {/* <BiBarChartSquare size={20} /> */}
                                <ContainerIcon style={{ width: "20px", height: "20px" }} />
                                {val?.label}
                                {/* <Chip
                                    label={'AC'}
                                    size="small"
                                    sx={{
                                        backgroundColor: "#E6F4EA",
                                        color: '#377E36',
                                        fontWeight: 600,
                                        fontSize: "12px",
                                        borderRadius: "4px",
                                        height: "20px",
                                    }}
                                /> */}
                                <Box
                                    component="span"
                                    sx={{
                                        fontSize: "13px",
                                        color: "text.secondary",
                                        ml: 0.5,
                                    }}
                                >
                                    ({
                                        (
                                            myWorkCountRes?.data?.data?.find(
                                                (item) => item.type.toLowerCase() === val?.key?.toLowerCase()
                                            )?.count ?? 0
                                        )
                                    } Pending for review)
                                </Box>
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <MyWorkLineOld type={val?.key} path={val?.path} myWorkListdata={expanded === val?.key ? expandedData : []} />
                        </AccordionDetails>
                    </Accordion>
                )
            })}
        </>
    );
};

export default MyWorkKPI;
